import PropTypes from "prop-types";

const ExcelPreviewTable = ({ rows }) => (
  <table id="excel-preview-table" aria-label="Vista previa de Excel">
    <tbody>
      {rows.map((row, rowIndex) => (
        <tr key={rowIndex}>
          {row.map((value, columnIndex) => (
            <td key={columnIndex}>{value}</td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

ExcelPreviewTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
};

export default ExcelPreviewTable;
